import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Tooltip, IconButton, TextField, Button, Typography, Divider } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import { AddShoppingCart, AddShoppingCartOutlined, AddShoppingCartRounded, AddShoppingCartSharp, AddShoppingCartTwoTone } from '@mui/icons-material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 3,
};

export default function CustomModalAdicionarItem(props: { data: any; openDetails: any; index: any; handleSetItem: any; ordemDigitacao?: number, temTabPreco?: boolean, filtroRef?: React.RefObject<HTMLInputElement> }) {
    const { data, handleSetItem } = props;

    const [open, setOpen] = React.useState(false);
    const [quantidade, setQuantidade] = React.useState<string>("");

    const [valor, setValor] = React.useState(data.valorTabela ?? data.valor ?? 0);
    const [observacao] = React.useState('');

    const inputRef = useRef<HTMLInputElement | null>(null);
    const valorRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (valorRef.current) {
            valorRef.current.setSelectionRange(0, 0); // cursor no início
        }
    }, []);

    const handleOpen = async () => setOpen(true);
    const handleClose = () => {
        setQuantidade("");
        setOpen(false);

        if (props.filtroRef?.current) {
            setTimeout(() => {
                props.filtroRef?.current?.focus();
            }, 100); // espera animação do modal
        }
    };

    const salvarItemPedido = () => {

        if (!quantidade || isNaN(parseFloat(quantidade)) || parseFloat(quantidade) <= 0 /* || !Number.isInteger(quantidade) */) {
            mostraMensagemErro('Por favor, insira uma quantidade válida (número maior que zero)');
            return;
        }

        const itemPedido = {
            idItem: data.idItem,
            idEmpresa: data.idEmpresa,
            ativo: data.ativo,
            idPedido: 0,
            ordemDigitacao: props.ordemDigitacao || 0,
            qtd: quantidade,
            valor: valor,
            valorIpi: (valor / 100) * data.percIpi,
            valorIcmsSubst: 0,
            valorDesconto: 0,
            total: (valor * parseFloat(quantidade)),
            observacao,
            descricao: data.descricao,
            codItem: data.codItem,
            percIpi: data.percIpi,
            codUnidade: data.codUnidade,
        };

        handleSetItem(itemPedido);
        handleClose();
    };

    return (
        <div>
            <Tooltip title="Adicionar">
                <IconButton onClick={handleOpen} sx={{ color: '#0965c1' }}>
                    <AddCircleIcon />
                </IconButton>
            </Tooltip>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-adicionar-item"
                aria-describedby="modal-adicionar-item-descricao"
            >
                <Box sx={style}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, marginBottom:0 }}>
                        <AddShoppingCart sx={{ fontSize: 20, color: '#0965c1' }} />
                        <Typography id="modal-modal-title" variant="subtitle1" component="h2" fontSize='16px' color='#334155'>
                            Adicionar Item ao Pedido
                        </Typography>
                    </Box>
                   
                   <Divider sx={{ width: '100%', marginBottom: 2.5 }} />


                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.45 }}>
                        <Box sx={{ flex: '1 1 43%' }}>
                            <TextField
                                inputRef={inputRef}
                                autoFocus
                                fullWidth
                                required
                                label="Quantidade"
                                InputLabelProps={{ shrink: true }}
                                type="number"
                                size="small"
                                value={quantidade}
                                onChange={(e) => {
                                    let value = e.target.value;

                                    if (!/^[0-9]*\.?[0-9]*$/.test(value)) return;

                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                        setQuantidade(value);
                                    }
                                }}
                                onBlur={() => {
                                    if (/^\d+\.$/.test(quantidade)) return;

                                    if (quantidade && !isNaN(parseFloat(quantidade))) {
                                        setQuantidade(parseFloat(quantidade).toString());
                                    }
                                }}
                                variant="outlined"
                                sx={{ '& .MuiInputBase-root': { height: 34 } }}
                                inputProps={{ step: "1" }}
                            />

                        </Box>
                        <Box sx={{ flex: '1 1 43%' }}>
                            <NumericFormat
                                value={valor}
                                onValueChange={(values) => {
                                    const { floatValue } = values;
                                    if (valor === 0 && floatValue !== 0) {
                                        setValor(floatValue);
                                        return;
                                    }

                                    setValor(floatValue ?? 0);
                                }}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={4}
                                fixedDecimalScale
                                allowNegative={false}
                                customInput={TextField}
                                label="Valor"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                required
                                size="small"
                                disabled={data.valorTabela || data.valor > 0}
                                variant="outlined"
                                sx={{ '& .MuiInputBase-root': { height: 34 } }}
                                inputRef={valorRef}
                                onFocus={() => {
                                    setTimeout(() => {
                                        valorRef.current?.setSelectionRange(0, 1);
                                        setValor(0);
                                    }, 0);
                                }}
                                inputProps={{ tabIndex: 2 }}
                            />
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: 1.25, marginTop: 1.25 }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleClose}
                                tabIndex={4} // botão cancelar
                                sx={{
                                    backgroundColor: "#EEFBFF",
                                    color: "#0965c1",
                                    minHeight: 30,
                                    fontSize: '14px',
                                    py: 0.4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    borderRadius: '6px',
                                    padding: '0 12px',
                                    width: '30%',
                                    height: '30px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    fontFamily: 'sans-serif',
                                    textTransform: 'none',
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={salvarItemPedido}
                                tabIndex={3} // botão salvar
                                sx={{
                                    backgroundColor: "#0965c1",
                                    color: "#fff",
                                    minHeight: 30,
                                    fontSize: '14px',
                                    py: 0.4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    borderRadius: '6px',
                                    padding: '0 12px',
                                    width: '30%',
                                    height: '30px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    fontFamily: 'sans-serif',
                                    textTransform: 'none',
                                }}
                            >
                                Salvar
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div >
    );
}
